import axios, { AxiosResponse } from 'axios';
import {
  AuthData,
  LoginFormValue,
  RecoveryCodes,
  ResetPassword,
  SendVerificationCode,
  User,
  VerificationCodeResponse,
  VerifyVerificationCode,
} from '../@types/login';

import { ILanguage, ILanguageParams } from '../@types/language';
import {
  IControllerNameDropdown,
  IGetActionOfController,
  //IPermissionDropdown,
  IPermissionParams,
  PermissionFormValues,
  permissions,
  //PermissionList,
} from '../@types/permission';
import { IRole, roleDetail, roleParams } from 'src/@types/role';
import { CreateUser, userParams, userDetail, userLogParams } from 'src/@types/createUser';

import { YearInterface, YearParams } from 'src/@types/Year';
import {
  DashBoardByCurrantDayAndProcessStatus,
  DashBoardByRequestCategoriesBeforeAndAfterDeadLine,
  DashBoardByUserBeforeAndAfterDeadLine,
} from 'src/@types/itsmsDashboard';
import {
  EmployeeAccountReport,
  IEmployee,
  IEmployeeDetails,
  IEmployeeParams,
} from 'src/@types/foamCompanyTypes/Employee';
import { IEmployeePosition, IEmployeePositionParams } from 'src/@types/EmployeePosition';

import { IPositionTitle, IPositionTitleParams } from 'src/@types/foamCompanyTypes/PositionTitle';
import { IJobPosition, IJobPositionParams } from 'src/@types/JobPosition';

import { ICountry } from 'src/@types/country';

import { UserReport } from 'src/@types/userReport';
import { Province, ProvinceParams } from 'src/@types/province';
import { District, DistrictParams } from 'src/@types/district';
import {
  IContractDetails,
  IContractDetailsParams,
} from 'src/@types/foamCompanyTypes/ContractDetails';

import { Application, ApplicationParams } from 'src/@types/application';
import {
  TrainingVideo,
  TrainingVideoParams,
} from 'src/@types/foamCompanyTypes/systemTypes/trainingVideo';
import { IContractType, IContractTypeParams } from 'src/@types/foamCompanyTypes/CategoryType';
import { IBlock, IBlockDetails, IBlockParams } from 'src/@types/Choqorak/Settings/Block';
import {
  ApproveDiscound,
  attachmentRemoveParam,
  ContractReport,
  IAttachment,
  IContractGetHistoryParam,
  IContractInfo,
  IContractInfoDetails,
  IContractInfoParams,
  IContractInfoReport,
  IContractReportParam,
} from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';

import {
  IContractPayment,
  IContractPaymentParams,
} from 'src/@types/Choqorak/MainTables/Finance/ContractPayment';
import { IDiscount, IDiscountParams } from 'src/@types/Choqorak/MainTables/Finance/Discount';
import {
  IFinanceReport,
  IFinanceReportParams,
} from 'src/@types/Choqorak/MainTables/Finance/FinanceReport';
import { IncomeCategorys, IncomeCategoryParams } from 'src/@types/Choqorak/Settings/IncomeCategory';
import {
  IncomeReports,
  IncomeReportParams,
} from 'src/@types/Choqorak/MainTables/Income/IncomeReport';
import { IMap, IMapParams } from 'src/@types/Choqorak/MainTables/Map/Map';
import {
  IShopForMap,
  IShopInfo,
  IShopParams,
  IShopReportParam,
  ShopDetail,
  ShopLocation,
  ShopReportData,
} from 'src/@types/Choqorak/MainTables/Shop/Shop';
import { IShopReport, IShopReportParams } from 'src/@types/Choqorak/MainTables/Shop/ShopReport';
import {
  ElectricBoxDetails,
  IElectricBox,
  IElectricBoxParams,
} from 'src/@types/Choqorak/Settings/ElectricBox';
import {
  IElectricMeter,
  IElectricMeterConsumptionParams,
  IElectricMeterParams,
} from 'src/@types/Choqorak/Settings/ElectricMeter';
import { IFloor, IFloorParams } from 'src/@types/Choqorak/Settings/Floor';
import { IShopContractType } from 'src/@types/Choqorak/Settings/ShopContractType';
import { IStatus, IStatusParams } from 'src/@types/Choqorak/Settings/Status';
import { IShopType, IShopTypeParams } from 'src/@types/Choqorak/Settings/ShopType';
import {
  Incomes,
  IncomeParams,
  IncomeRepotParam,
  IncomReportData,
} from 'src/@types/Choqorak/MainTables/Income/Income';
import {
  CustomerAccountReport,
  ICustomer,
  ICustomerDetails,
  ICustomerParams,
} from 'src/@types/Choqorak/MainTables/Contract/Customer';
import { ICurrencyType, ICurrencyTypeParams } from 'src/@types/Choqorak/Settings/CurrencyType';
import {
  IElectricityPrice,
  IElectricityPriceParams,
} from 'src/@types/Choqorak/Settings/ElectricityPrice';
import {
  IGeneratRentPaymentList,
  IGetRentHistoryParam,
  IRentAdvancePayment,
  IRentPayment,
  IRentPaymentDelete,
  IRentPaymentDetailsParam,
  IRentPaymentParams,
  IRentPaymentReport,
  RentReportData,
} from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import {
  ITermsAndCondition,
  ITermsAndConditionParams,
} from 'src/@types/Choqorak/Settings/TermsAndCondition';
import {
  ElectricReport,
  IElectricityPayment,
  IElectricityPaymentDelete,
  IElectricityPaymentDetailsParam,
  IElectricityPaymentParams,
  IElectricityPaymentReport,
  IGetHistoryParam,
  IRecievePayment,
} from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';
import { ShopDashboardData } from 'src/@types/Choqorak/Dashboards/Dashboard';
import { notificationparams } from 'src/@types/notification';
import { FinancialPaymentParams, IFinancialPayment } from 'src/@types/Choqorak/MainTables/FinancialPayment/FinancialPayment';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
//axios.defaults.baseURL = 'http://localhost:9090/api/';

axios.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('mewToken');
    if (token) config.headers!.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    console.log('err');
    throw error;
  }
);

const responseBody = <T>(respons: AxiosResponse<T>) => respons.data;

///<T> we added generic type for it so we can latter assign any kind of data is requested
const requests = {
  get: <T>(url: string) =>
    axios
      .get<T>(url, {
        withCredentials: true,
      })
      .then(responseBody),
  post: <T>(url: string, body: {}) =>
    axios.post<T>(url, body, { withCredentials: true }).then(responseBody),
  put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
  del: <T>(url: string, body: {}) => axios.delete<T>(url, body).then(responseBody),
};

// Login
const Logins = {
  login: (login: LoginFormValue) => requests.post<User>('/Auth/SignIn', login),
  loginWith2fa: (login: LoginFormValue) => requests.post<User>('/Auth/SignInWith2Fa', login),
  disable2fa: () => requests.get<any>('/Auth/DisableTwoFactorAuthentication'),
  generate2faQrCode: () => requests.get<AuthData>('/Auth/GenerateQrCodeData'),
  enableTwoFactorAuthentication: (Code: string) =>
    requests.get<RecoveryCodes>(`Auth/EnableTwoFactorAuthentication?Code=${Code}`),
  loginWith2faRecoveryCode: (login: LoginFormValue) =>
    requests.post<User>('/Auth/SignInWithRecoveryCode', login),
  SendCode: (sendCode: SendVerificationCode) =>
    requests.post<void>('/Auth/ForgetPassword-SendVerificationCode', sendCode),
  VerifyCode: (verifyCode: VerifyVerificationCode) =>
    requests.post<VerificationCodeResponse>(
      '/Auth/ForgetPassword-RecieveVerificationCode',
      verifyCode
    ),
  ResetPassword: (resetPassword: ResetPassword) =>
    requests.post<void>('/Auth/ForgetPassword-PasswordReset', resetPassword),
  current: () => requests.post<User>('/Auth/refresh-token', {}),
  refreshToken: () => requests.post<User>('/Auth/refresh-token', {}),
  sendCode: (sendCode: SendVerificationCode) =>
    requests.post<SendVerificationCode>('/Auth/ForgetPassword-SendVerificationCode', sendCode),
  verifyCode: (verifyCode: VerifyVerificationCode) =>
    requests.post<VerificationCodeResponse>(
      '/Auth/ForgetPassword-RecieveVerificationCode',
      verifyCode
    ),
  resetPassword: (resetPassword: ResetPassword) =>
    requests.post<void>('/Auth/ForgetPassword-PasswordReset', resetPassword),
};

// Permission
const Permissions = {
  create: (permission: PermissionFormValues) => requests.post<void>('/Permission', permission),
  getList: (param: IPermissionParams) =>
    axios.post<any>('/Permission/List', param, { withCredentials: true }),
  update: (permission: permissions) =>
    requests.put<void>(`/Permission/${permission.id}`, permission),
  delete: (id: number, remark: string) => axios.delete<void>(`/Permission/${id}`, { data: remark }),
  // getList: (param: IPermissionParams) => axios.post<any>('/Permission/GetControllers', param),
  List: (param: IPermissionParams) =>
    axios.post<any>('/Permission/List', param, { withCredentials: true }),
  getPermissionDDL: (id: number) =>
    axios.get<any>(`/Permission/Permission-DropDownList/${id}`, {
      withCredentials: true,
    }),
};

// Get Controller Name
const ControllerNames = {
  getContollerList: (name: string) =>
    requests.get<IControllerNameDropdown[]>(`/Permission/Get-Controllers-Dropdown/${name}`), //
  getActionOfController: (name: string) =>
    requests.get<IGetActionOfController[]>(
      `/Permission/GetActionOfController?ControllerName=${name}`
    ),
  getApplicationList: () => axios.get<any>('/Application/GetAllApplication').then(responseBody),
  getApplicationListForPermis: () => axios.get<any>('/Permission/Get-Application-Dropdown'),
};

// Language
const Lanugages = {
  create: (language: ILanguage) => axios.post<any>('/Language', language),
  getList: (param: ILanguageParams) =>
    axios.post<any>('/Language/Get-Language-List', param, { withCredentials: true }),
  getLanguageDDL: () =>
    axios.get<any>('/Language/Get-Language-DDL', {
      withCredentials: true,
    }),
  // getList: () => axios.post<any>('/Language/Get-Language-List'),
  update: (language: ILanguage) => requests.put<void>(`/Language/${language.id}`, language),
  delete: (id: number, remark: string) => axios.delete<void>(`/Language/${id}`, { data: remark }),
};

// Employee
const Employees = {
  create: (data: IEmployee, file: Blob) => {
    let formData = new FormData();

    formData.append('englishFirstName', data.englishFirstName!);
    formData.append('pashtoFirstName', data.pashtoFirstName!);
    formData.append('englishSurName', data.englishSurName!);
    formData.append('pashtoSurName', data.pashtoSurName!);
    formData.append('englishFatherName', data.englishFatherName!);
    formData.append('pashtoFatherName', data.pashtoFatherName!);
    formData.append('englishGrandFatherName', data.englishGrandFatherName!);
    formData.append('pashtoGrandFatherName', data.pashtoGrandFatherName!);
    formData.append('tazkiraNo', data.tazkiraNo!);
    formData.append('branchId', data.branchId!.toString());
    formData.append('gender', data.gender!.toString());
    formData.append('bloodGroup', data.bloodGroup!.toString());
    formData.append('tazkiraTypeId', data.tazkiraTypeId!.toString());
    formData.append('dateOfBirth', data.dateOfBirth!.toDateString());
    formData.append('joldNo', data.joldNo!);
    formData.append('pageNo', data.pageNo!);
    formData.append('regNo', data.regNo!);
    formData.append('phoneNumber', data.phoneNumber!);
    formData.append('temporaryAddress', data.temporaryAddress!);
    formData.append('personalEmail', data.personalEmail!);
    formData.append('permenantAddress', data.permenantAddress!);
    formData.append('emergencyPhoneNumber', data.emergencyPhoneNumber!);
    formData.append('joinDate', data.joinDate!.toDateString());
    formData.append('profilePhoto', file);
    formData.append('isActive', data.isActive!.toString());
    return axios.post<IEmployee, any>('/EmployeeProfile', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  // create: (employee: IEmployee) => requests.post<void>('/Employee', employee),
  getList: (param: IEmployeeParams) =>
    axios.post<any>(`/EmployeeProfile/GetList`, param, { withCredentials: true }),
  update: (data: IEmployee, file: Blob) => {
    let formData = new FormData();

    formData.append('englishFirstName', data.englishFirstName!);
    formData.append('pashtoFirstName', data.pashtoFirstName!);
    formData.append('englishSurName', data.englishSurName!);
    formData.append('pashtoSurName', data.pashtoSurName!);
    formData.append('englishFatherName', data.englishFatherName!);
    formData.append('pashtoFatherName', data.pashtoFatherName!);
    formData.append('englishGrandFatherName', data.englishGrandFatherName!);
    formData.append('pashtoGrandFatherName', data.pashtoGrandFatherName!);
    formData.append('tazkiraNo', data.tazkiraNo!);
    formData.append('gender', data.gender!.toString());
    formData.append('bloodGroup', data.bloodGroup!.toString());
    formData.append('tazkiraTypeId', data.tazkiraTypeId!.toString());
    formData.append('dateOfBirth', data.dateOfBirth!.toDateString());
    formData.append('joldNo', data.joldNo!);
    formData.append('pageNo', data.pageNo!);
    formData.append('regNo', data.regNo!);
    formData.append('phoneNumber', data.phoneNumber!);
    formData.append('temporaryAddress', data.temporaryAddress!);
    formData.append('permenantAddress', data.permenantAddress!);
    formData.append('emergencyPhoneNumber', data.emergencyPhoneNumber!);
    formData.append('personalEmail', data.personalEmail!);
    formData.append('joinDate', data.joinDate!.toDateString());
    formData.append('profilePhoto', file);
    formData.append('isActive', data.isActive!.toString());
    // formData.append('isCurrent', data.isCurrent!.toString());
    if (file) {
      formData.append('profilePhoto', file);
    }
    return axios.put<IEmployee>(`/EmployeeProfile/${data.id}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  //update: (emp: IEmployee) => requests.put<void>(`/Employee/${emp.id}`, emp),
  detail: (empId: any) => requests.get<void>(`/EmployeeProfile/GetDetail/${empId}`),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/EmployeeProfile/${id}`, { data: remark }),
  employeeDetail: (id: number) =>
    requests.get<IEmployeeDetails>(`/EmployeeProfile/GetDetail/${id}`),
  EmpDDLByCurrentBranch: () => axios.get<any>(`/EmployeeProfile/GetEmplyeeDDLOfCurrentBranch`),
  EmpDDL: (empStatus: any) =>
    axios.get<any>(`/EmployeeProfile/GetEmployeeProfileDDL/${empStatus}`, {
      withCredentials: true,
    }),
  getEmpRelatedDepartmentDDL: () =>
    axios.get<any>(`/EmployeeProfile/GetRelatedUserInDepartment`, {
      withCredentials: true,
    }),
  getEmpForEdit: (id: number) =>
    axios.get<any>(`/EmployeeProfile/GetEmployeeProfileForEdit/${id}`, { withCredentials: true }),

  getEmployeeAccountReport: (param: EmployeeAccountReport) =>
    axios.post<any>(`/EmployeeReport/Get-Employee-Reports`, param, { withCredentials: true }),
};

// Province
const province = {
  create: (province: Province) => requests.post<void>('/Province', province),
  getList: (param: ProvinceParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (province: Province) => requests.put<void>(`/Province/${province.id}`, province),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  provinceDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
  provinceDDLByMainRegion: (MainRegionID: number) =>
    axios.get<any>(`/Province/GetProvinceByMainRegion/${MainRegionID}`, {
      withCredentials: true,
    }),
  // provinceDetail: (id: number) => axios.get<MainRegion>(`/Province/GetDetail/${id}`, {}),
};

// District
const district = {
  create: (district: District) => requests.post<void>('/District', district),
  getList: (param: DistrictParams) =>
    axios.post<any>(`/District/GetList`, param, { withCredentials: true }),
  update: (district: District) => requests.put<void>(`/District/${district.id}`, district),
  delete: (id: number, remark: string) => axios.delete<void>(`/District/${id}`, { data: remark }),
  districtDDL: (id: number) =>
    axios.get<any>(`/District/GetDistrictDDL/${id}`, {
      withCredentials: true,
    }),
  districtDetail: (id: number) =>
    axios.get<District>(`/District/GetDetail/${id}`, {
      withCredentials: true,
    }),
};

// Employee Position
const EmployeesPosition = {
  create: (Applicant: IEmployeePosition) => requests.post<void>('/EmployeePosition', Applicant),
  getList: (param: IEmployeePositionParams) =>
    axios.post<any>(`/EmployeePosition/GetList`, param, { withCredentials: true }),
  update: (Applicant: IEmployeePosition) =>
    requests.put<void>(`/EmployeePosition/${Applicant.id}`, Applicant),
  detail: (ApplicantId: any) => requests.get<void>(`/EmployeePosition/GetDetail/${ApplicantId}`),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/CardDetails/${id}`, { data: remark }),
};

// PositionTitle
const PositionTitle = {
  create: (PositionTitle: IPositionTitle) => requests.post<void>('/PositionTitle', PositionTitle),
  getList: (param: IPositionTitleParams) =>
    axios.post<any>(`/PositionTitle/GetList`, param, { withCredentials: true }),
  update: (PositionTitle: IPositionTitle) =>
    requests.put<void>(`/PositionTitle/${PositionTitle.id}`, PositionTitle),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/PositionTitle/${id}`, { data: remark }),
  DDl: (departmentId: any) =>
    axios.get<any>(`/PositionTitle/GetDropDownList/1`, { withCredentials: true }),
};

// JobPosition
const JobPosition = {
  create: (JobPosition: IJobPosition) => requests.post<void>('/JobPosition', JobPosition),
  getList: (param: IJobPositionParams) =>
    axios.post<any>(`/JobPosition/GetList`, param, { withCredentials: true }),
  update: (JobPosition: IJobPosition) =>
    requests.put<void>(`/JobPosition/${JobPosition.id}`, JobPosition),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/JobPosition/${id}`, { data: remark }),
  DDl: () => axios.get<any>('/JobPosition/GetJobPositionDDL'),
};

// Roles
const RolesAgent = {
  create: (roles: IRole) => requests.post<void>('/Role', roles),
  getList: (param: roleParams) => axios.post<any>('/Role/List', param, { withCredentials: true }),
  getRoleDDl: () =>
    axios.get<any>('/Role/RolesDropdown', {
      withCredentials: true,
    }),
  update: (roles: IRole) => requests.put<void>(`/Role/${roles.id}`, roles),
  getDetail: (id: number) => requests.get<roleDetail>(`/Role/${id}`),
  delete: (id: number, remark: string) => axios.delete<void>(`/Role/${id}`, { data: remark }),
};

// User Creation Agent
const createUser = {
  create1: (data: CreateUser) => axios.post<CreateUser, any>('/User/CreateUser', data),
  update: (data: CreateUser) => axios.put<CreateUser>('/User/UpdateUser', data),
  create: (data: CreateUser) => requests.post<void>('/User/CreateUser', data),
  getUsers: (param: userParams) => axios.post<any>('/User/GetUsers', param),
  getUsersLog: (param: userLogParams) => axios.post<any>('/User/UserLog', param),
  userDetail: (id: string) => requests.get<userDetail>(`/User/GetUserByID/${id}`),

  //request axios
  delete: (Id: string, remarks: string) => axios.delete<void>(`/User/${Id}`, { data: { remarks } }),
  resetPassword: (ID: string, NewPassword: string) =>
    requests.post<void>(`/User/PasswordReset`, { ID, NewPassword }),
  changePassword: (Id: string, currentPassword: string, newPassword: string) =>
    axios.post<void>(`/User/ChangePassword/`, { Id, currentPassword, newPassword }),
  userActivate: (id: string, isActive: boolean) =>
    axios.post<void>(`/User/UserActivation/`, { id, isActive }),
  userProfile: () => axios.get<userDetail>(`/Profile/`),
  userDropDownbyDepartment: (dep: any, isLoggedUser?: any) =>
    axios.get<any>(`/User/UsersDropdown/${dep}/${isLoggedUser}`, {
      withCredentials: true,
    }),
  childUserDDl: () =>
    axios.get<any>(`/User/ChildUsersDropdown/`, {
      withCredentials: true,
    }),
  UserDDlByOrganization: (organizationId: any) =>
    axios.get<any>(`/User/UsersDropdownByOrg/${organizationId}`, {
      withCredentials: true,
    }),
  getUserReport: (param: UserReport) =>
    axios.post(`/UserReport/Get-User-Reports`, param, { withCredentials: true }),
};

//Year
const Years = {
  create: (Year: YearInterface) => requests.post<void>('/Year', Year),
  getList: (Year: YearParams) => axios.post<any>('/Year/GetList', Year, { withCredentials: true }),
  delete: (id: number, remarks: string) => axios.delete<void>(`/Year/${id}`, { data: remarks }),
  update: (Year: YearInterface) => requests.put<void>(`/Year/${Year.id}`, Year),
  YearDDL: () =>
    axios.get<any>(`/Year/GetYearDDL`, {
      withCredentials: true,
    }),
};

const changeLanguage = {
  ChangeLanguage: (language: any) =>
    axios.post<any>(`/ChangeLanguage/${language} `, {}, { withCredentials: true }),
  getIpAndMac: () =>
    axios.get<any>(`/IPandMACAddress/GetIPandMACAddress`, {
      withCredentials: true,
    }),
};
// ContractType
const ContractType = {
  create: (ContractType: IContractType) => requests.post<void>('/ContractType', ContractType),
  getList: (param: IContractTypeParams) =>
    axios.post<any>(`/ContractType/GetList`, param, { withCredentials: true }),
  update: (ContractType: IContractType) =>
    requests.put<void>(`/ContractType/${ContractType.id}`, ContractType),
  // detail: (ContractTypeId: any) =>
  //   requests.get<void>(`/ContractType/GetDetail/${ContractTypeId}`),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/ContractType/${id}`, { data: remark }),
  DDl: () =>
    axios.get<any>('/ContractType/GetDropDownList', {
      withCredentials: true,
    }),
};

// ContractType
const HRContractType = {
  create: (ContractType: IContractType) => requests.post<void>('/HRContractType', ContractType),
  getList: (param: IContractTypeParams) =>
    axios.post<any>(`/HRContractType/GetList`, param, { withCredentials: true }),
  update: (ContractType: IContractType) =>
    requests.put<void>(`/HRContractType/${ContractType.id}`, ContractType),
  // detail: (ContractTypeId: any) =>
  //   requests.get<void>(`/ContractType/GetDetail/${ContractTypeId}`),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/HRContractType/${id}`, { data: remark }),
  DDl: () =>
    axios.get<any>('/HRContractType/GetDropDownList', {
      withCredentials: true,
    }),
};
const itsmsDashboard = {
  ByRequestCategoryBeforeAndAfterDeadline: (status: boolean) =>
    axios.get<DashBoardByRequestCategoriesBeforeAndAfterDeadLine[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByRequestCategoriesBeforeAndAfterDeadLine/${status}`
    ),
  ByUserBeforeAndAfterDeadLine: (status: boolean) =>
    axios.get<DashBoardByUserBeforeAndAfterDeadLine[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByUserBeforeAndAfterDeadLine/${status}`
    ),
  pendingTickets: () =>
    axios.get<DashBoardByCurrantDayAndProcessStatus[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByCurrantDayVisitorAndProcessStatus/${3}`
    ),
  approvedTickets: () =>
    axios.get<DashBoardByCurrantDayAndProcessStatus[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByCurrantDayVisitorAndProcessStatus/${5}`
    ),
  processStartTickets: () =>
    axios.get<DashBoardByCurrantDayAndProcessStatus[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByCurrantDayVisitorAndProcessStatus/${10}`
    ),
  completedTickets: () =>
    axios.get<DashBoardByCurrantDayAndProcessStatus[]>(
      `ITSMSDashBoardsAndReports/DashBoard-ByCurrantDayVisitorAndProcessStatus/${1}`
    ),
};

// NPFX MARKET AGENT START HERE
// AssetType

// Application
const Applications = {
  create: (application: Application) => requests.post<void>('/Application', application),
  getList: (param: ApplicationParams) =>
    axios.post<any>('/Application/Get-Application-List', param, { withCredentials: true }),
  update: (application: Application) =>
    requests.put<void>(`/Application/${application.id}`, application),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/Application/${id}`, { data: remark }),
  getApplicationddl: () =>
    axios.get<any>('/Application/GetApplicationDDL', {
      withCredentials: true,
    }),
};

// CurrencyType

// Country Lookup
const Country = {
  getList: (param: ICountry) =>
    axios.post<any>(`/Country/GetList`, param, { withCredentials: true }),
  DDl: () =>
    axios.get<any>('/Country/GetDropDownList', {
      withCredentials: true,
    }),
};

// Get Active Employee Lookup
const GetActiveEmp = {
  DDl: (GetActiveEmp: any) =>
    axios.get<any>(`/EmployeeProfile/GetActiveEmplyeeDDLByDepartment/${GetActiveEmp}`, {
      withCredentials: true,
    }),
};

// ContractDetails
const ContractDetails = {
  create: (Applicant: IContractDetails) => requests.post<void>('/ContractDetails', Applicant),
  getList: (param: IContractDetailsParams, empId: any) =>
    axios.post<any>(`/ContractDetails/GetList/${empId}`, param, { withCredentials: true }),
  update: (Applicant: IContractDetails) =>
    requests.put<void>(`/ContractDetails/${Applicant.id}`, Applicant),
  detail: (ApplicantId: any) => requests.get<void>(`/ContractDetails/GetDetail/${ApplicantId}`),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/ContractDetails/${id}`, { data: remark }),
  getEmpCurrentContract: (id: number) =>
    axios.get<any>(`/ContractDetails/GetEmployeeCurrentContract/${id}`, { withCredentials: true }),
};

// Get Active Employee Lookup
const GetParentEmp = {
  DDl: (GetParentEmp: any) =>
    axios.get<any>(`/Department/GetParentDepartment/${GetParentEmp}`, {
      withCredentials: true,
    }),
  HighLevelEmployeeDDl: () =>
    axios.get<any>('/EmployeeProfile/GetHighLevelEmployees', {
      withCredentials: true,
    }),
  GetAuthorithyEmployeeDDl: () =>
    axios.get<any>('/EmployeeProfile/GetAuthoritiesDDL', {
      withCredentials: true,
    }),
};
// Foam Company Api Start

const trainingVideoAgent = {
  create: (data: TrainingVideo, poster: Blob, dariVideo: Blob, pashtoVideo: Blob) => {
    const formData: FormData = new FormData();
    formData.append('dariVideoPath', dariVideo);
    formData.append('pashtoVideoPath', pashtoVideo);
    formData.append('poster', poster);
    formData.append('dariTitle', data.dariTitle!);
    formData.append('pashtoTitle', data.pashtoTitle!);
    formData.append('application', data.application!);

    return requests.post<TrainingVideo>('/TrainingVideo', formData);
  },
  update: (data: TrainingVideo, poster: Blob, dariVideo: Blob, pashtoVideo: Blob) => {
    const formData: FormData = new FormData();
    formData.append('dariVideoPath', dariVideo);
    formData.append('pashtoVideoPath', pashtoVideo);
    formData.append('poster', poster);
    formData.append('dariTitle', data.dariTitle!);
    formData.append('pashtoTitle', data.pashtoTitle!);
    formData.append('application', data.application!);

    return requests.put<TrainingVideo>(`/TrainingVideo/${data.id}`, formData);
  },
  getList: (params: TrainingVideoParams) => axios.post<any>(`/TrainingVideo/GetList`, params),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/TrainingVideo/${id}`, { data: remark }),
};

//#region Choqorak
//#region Notification
const Notification = {
  getNotificationList: (param: notificationparams) =>
    axios.post<any>(`/Notification/GetList`, param, { withCredentials: true }),
  readNotification: (id: number) => axios.put<void>(`/Notification/ShortUpdate/${id}`, {}),
  getNotificationUnreadList: () => axios.post<any>(`/Notification/GetUnreadCount`, {}),
};
//#endregion
//#region settings

//#region Block
const Block = {
  create: (Block: IBlock) => requests.post<void>('/Block', Block),
  getList: (param: IBlockParams) =>
    axios.post<any>(`/Block/GetList`, param, { withCredentials: true }),
  update: (Block: IBlock) => requests.put<void>(`/Block/${Block.blockId}`, Block),
  delete: (blockId: number, remark: string) =>
    axios.delete<void>(`/Block/${blockId}`, { data: remark }),

  BlockDDL: () =>
    axios.get<any>(`/Block/GetBlockDDL`, {
      withCredentials: true,
    }),
  getDetail: (blockId: number) => requests.get<IBlockDetails>(`/Block/GetDetail/${blockId}`),
};
//#endregion

//#region ElectricBox
const ElectricBox = {
  create: (ElectricBox: IElectricBox) => requests.post<void>('/ElectricBox', ElectricBox),
  getList: (param: IElectricBoxParams) =>
    axios.post<any>(`/ElectricBox/GetList`, param, { withCredentials: true }),
  update: (ElectricBox: IElectricBox) =>
    requests.put<void>(`/ElectricBox/${ElectricBox.electricBoxId}`, ElectricBox),
  delete: (electricBoxId: number, remark: string) =>
    axios.delete<void>(`/ElectricBox/${electricBoxId}`, { data: remark }),
  ElectricBoxDDL: () =>
    axios.get<any>(`/ElectricBox/GetElectricBoxDDL`, {
      withCredentials: true,
    }),
  getDetail: (electricBoxId: number) =>
    requests.get<ElectricBoxDetails>(`/ElectricBox/GetDetail/${electricBoxId}`),
};
//#endregion

//#region ElectricMeter
const ElectricMeter = {
  create: (ElectricMeter: IElectricMeter) => requests.post<void>('/ElectricMeter', ElectricMeter),
  getList: (param: IElectricMeterParams) =>
    axios.post<any>(`/ElectricMeter/GetList`, param, { withCredentials: true }),
  update: (ElectricMeter: IElectricMeter) =>
    requests.put<void>(`/ElectricMeter/${ElectricMeter.electricMeterId}`, ElectricMeter),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/ElectricMeter/${id}`, { data: remark }),
  ElectricMeterDDL: (electricBoxId: number, ShowAssignedElectricMeter?: boolean) =>
    axios.get<any>(
      `/ElectricMeter/GetElectricMeterDDL/${electricBoxId}?ShowAssignedElectricMeter=${ShowAssignedElectricMeter}`,
      {
        withCredentials: true,
      }
    ),
  getDetail: (id: number) => requests.get<IElectricMeter>(`/ElectricMeter/${id}`),
  GetConsumptionList: (param: IElectricMeterConsumptionParams) =>
    axios.post<any>(`/ElectricMeter/GetConsumptionList`, param, { withCredentials: true }),
};
//#endregion

//#region Floor
const Floor = {
  create: (data: IFloor, file: Blob) => {
    let formData = new FormData();
    formData.append('floorCode', data.floorCode!);
    formData.append('buildingId', data.buildingId!.toString());
    formData.append('floorMap', file);
    return axios.post<IFloor, any>('/Floor', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  getList: (param: IFloorParams) =>
    axios.post<any>(`/Floor/GetList/1`, param, { withCredentials: true }),
  update: (data: IFloor, floorMap?: Blob) => {
    let formData = new FormData();

    formData.append('floorId', data.floorId!.toString());
    formData.append('floorCode', data.floorCode!);
    formData.append('buildingId', data.buildingId!.toString());

    // formData.append('isCurrent', data.isCurrent!.toString());

    formData.append('attachment', floorMap!);

    return axios.put<IFloor>(`/Floor/${data.floorId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  delete: (floorId: number, remark: string) =>
    axios.delete<void>(`/Floor/${floorId}`, { data: remark }),
  FloorDDL: () =>
    axios.get<any>(`/Floor/GetFloorDDL/1`, {
      withCredentials: true,
    }),
  getDetail: (id: number) => requests.get<IFloor>(`/Floor/GetDetail/${id}`),
};
//#endregion

//#region IncomeCategory
const IncomeCategory = {
  create: (IncomeCategory: IncomeCategorys) =>
    requests.post<void>('/IncomeCategory', IncomeCategory),
  getList: (param: IncomeCategoryParams) =>
    axios.post<any>(`/IncomeCategory/GetList`, param, { withCredentials: true }),
  update: (IncomeCategory: IncomeCategorys) =>
    requests.put<void>(`/IncomeCategory/${IncomeCategory.id}`, IncomeCategory),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/IncomeCategory/${id}`, { data: remark }),
  IncomeCategoryDDL: () =>
    axios.get<any>(`/IncomeCategory/GetIncomeCategoryDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region ShopContractType
const ShopContractType = {
  create: (ShopContractType: IShopContractType) =>
    requests.post<void>('/ContractType', ShopContractType),
  getList: (param: IContractTypeParams) =>
    axios.post<any>(`/ContractType/GetList`, param, { withCredentials: true }),
  update: (ShopContractType: IShopContractType) =>
    requests.put<void>(`/ContractType/${ShopContractType.id}`, ShopContractType),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/ContractType/${id}`, { data: remark }),
  ShopContractTypeDDL: () =>
    axios.get<any>(`/ContractType/GetContractTypeDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region Status
const Status = {
  create: (Status: IStatus) => requests.post<void>('/Status', Status),
  getList: (param: IStatusParams) =>
    axios.post<any>(`/Status/GetList`, param, { withCredentials: true }),
  update: (Status: IStatus) => requests.put<void>(`/Status/${Status.id}`, Status),
  delete: (id: number, remark: string) => axios.delete<void>(`/Status/${id}`, { data: remark }),
  StatusDDL: (type?: number) =>
    axios.get<any>(`/Status/GetStatusDDL/${type}`, {
      withCredentials: true,
    }),
};
//#endregion

//#region CurrencyType
const CurrencyType = {
  create: (CurrencyType: ICurrencyType) => requests.post<void>('/CurrencyType', CurrencyType),
  getList: (param: ICurrencyTypeParams) =>
    axios.post<any>(`/CurrencyType/GetList`, param, { withCredentials: true }),
  update: (CurrencyType: ICurrencyType) =>
    requests.put<void>(`/CurrencyType/${CurrencyType.id}`, CurrencyType),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/CurrencyType/${id}`, { data: remark }),
  CurrencyTypeDDL: () =>
    axios.get<any>(`/CurrencyType/GetCurrencyTypeDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region ShopType
const ShopType = {
  create: (ShopType: IShopType) => requests.post<void>('/ShopType', ShopType),
  getList: (param: IShopTypeParams) =>
    axios.post<any>(`/ShopType/GetList`, param, { withCredentials: true }),
  update: (ShopType: IShopType) => requests.put<void>(`/ShopType/${ShopType.id}`, ShopType),
  delete: (id: number, remark: string) => axios.delete<void>(`/ShopType/${id}`, { data: remark }),
  ShopTypeDDL: () =>
    axios.get<any>(`/ShopType/GetShopTypeDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region TermsAndCondition
const TermsAndCondition = {
  create: (TermsAndCondition: ITermsAndCondition) =>
    requests.post<void>('/TermsAndCondition', TermsAndCondition),
  getList: (param: ITermsAndConditionParams) =>
    axios.post<any>(`/TermsAndCondition/GetList`, param, { withCredentials: true }),
  update: (TermsAndCondition: ITermsAndCondition) =>
    requests.put<void>(
      `/TermsAndCondition/${TermsAndCondition.termAndConditionId}`,
      TermsAndCondition
    ),
  delete: (id: number, remark: string) =>
    axios.delete<void>(`/TermsAndCondition/${id}`, { data: remark }),
  TermsAndConditionDDL: (type: number) =>
    axios.get<any>(`/TermsAndCondition/GetTermsAndConditionDDL/${type}`, {
      withCredentials: true,
    }),
};
//#endregion

//#endregion

//#region Main Tables

//#region ContractInfo
const ContractInfo = {
  create: (ContractInfo: IContractInfo) => requests.post<void>('/Contract', ContractInfo),
  getList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList`, param, { withCredentials: true }),
  unapprovedList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/unapproved`, param, { withCredentials: true }),
  approvedList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/approved`, param, { withCredentials: true }),
  expiredList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/expired`, param, { withCredentials: true }),
  abouttoexpireList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/about-to-expire`, param, { withCredentials: true }),
  terminatedList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/terminated`, param, { withCredentials: true }),

  activeContractList: (param: IContractInfoParams) =>
    axios.post<any>(`/Contract/GetList/active`, param, { withCredentials: true }),
  update: (ContractInfo: IContractInfo) =>
    requests.put<void>(`/Contract/${ContractInfo.contractId}`, ContractInfo),
  delete: (id: number, remark: string) => axios.delete<void>(`/Contract/${id}`, { data: remark }),
  deleteAttachment: (id: number) => axios.post<void>(`/Contract/remove-Attachment/${id}`),
  ContractInfoDDL: () =>
    axios.get<any>(`/Contract/GetContractDDL`, {
      withCredentials: true,
    }),

  ContractTerminate: (ContractInfo: IContractInfo) =>
    requests.put<void>(`/Contract/Terminate/${ContractInfo.contractId}`, ContractInfo),

  ExpirationSettlement: (ContractInfo: IContractInfo) =>
    requests.put<void>(`/Contract/ExpirationSettlement/${ContractInfo.contractId}`, ContractInfo),

  getDetail: (id: number) => requests.get<IContractInfoDetails>(`/Contract/GetDetail/${id}`),
  Attachment: (data: IAttachment, attach: Blob) => {
    let formData = new FormData();

    formData.append('contractId', data?.contractId!.toString());
    formData.append('attachment', attach);
    return axios.post<IAttachment, any>(`/Contract/Add-Attachment`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },

  ContractExtend: (data: IContractInfo, attach: Blob) => {
    // console.log(data);
    let formData = new FormData();
    formData.append('contractId', data.contractId!.toString());
    formData.append('contractDuration', data.contractDuration!.toString());
    formData.append('duration', data.duration!.toString());
    formData.append('contractStartDate', data.contractStartDate!.toISOString().split('T')[0]);
    formData.append('contractEndDate', data.contractEndDate!.toISOString().split('T')[0]);
    if (data.discountStartDate && data.discountEndDate) {
      formData.append('discountStartDate', data.discountStartDate!.toISOString().split('T')[0]);
      formData.append('discountEndDate', data.discountEndDate!.toISOString().split('T')[0]);
    }

    formData.append('finalRentPerMonth', data.finalRentPerMonth!.toString());
    if (data.attachment) {
      formData.append('Attachment', attach);
    }

    return axios.post<IContractInfo, any>(`/Contract/Extend/${data.contractId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
    // let formData = new FormData();

    // formData.append('contractStartDate', data.contractStartDate!.toString());
    // formData.append('contractEndDate', data.contractEndDate!.toString());
    // formData.append('finalRentPerMonth', data.finalRentPerMonth!.toString());
    // formData.append('discountEndDate', data.discountEndDate!.toString());
    // formData.append('discountStartDate', data.discountStartDate!.toString());
    // formData.append('Attachment', attach);
    // return axios.post<IContractInfo, any>(`/Contract/Extend/${data.contractId}`, formData, {
    //   headers: { 'Content-type': 'multipart/form-data' },
    // });
  },

  ContracLock: (data: IContractInfo, attach: Blob) => {
    let formData = new FormData();
    if (data.contractElectricMeterStartDigree) {
      formData.append(
        'contractElectricMeterStartDigree',
        data.contractElectricMeterStartDigree!.toString()
      );
    }

    formData.append('attachment', attach);
    return axios.put<IContractInfo, any>(`/Contract/Lock/${data.contractId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  // ApproveDiscount: (ApproveDiscound: ApproveDiscound) =>
  //   requests.put<void>(`/Contract/Approve/${ApproveDiscound.contractId}`, ApproveDiscound),
  ApproveDiscount: (ApproveDiscound: ApproveDiscound, attach: Blob) => {
    let formData = new FormData();
    formData.append('contractId', ApproveDiscound.contractId!.toString());
    formData.append('discountStartDate', ApproveDiscound.discountStartDate!.toDateString());
    formData.append('discountEndDate', ApproveDiscound.discountEndDate!.toDateString());
    formData.append('finalRentPerMonth', ApproveDiscound.finalRentPerMonth!.toString());
    formData.append('isApproved', ApproveDiscound.isApproved!.toString());
    formData.append('attachment', attach);
    return axios.put<ApproveDiscound, any>(
      `/Contract/Approve/${ApproveDiscound.contractId}`,
      formData,
      {
        headers: { 'Content-type': 'multipart/form-data' },
      }
    );
  },

  RecievedAdvancePay: (Param: IContractInfo, attach: Blob) => {
    let formData = new FormData();
    formData.append('contractId', Param.contractId!.toString());

    formData.append('attachment', attach);
    return axios.put<IContractInfo, any>(
      `/Contract/RecievedAdvance/${Param.contractId}`,
      formData,
      {
        headers: { 'Content-type': 'multipart/form-data' },
      }
    );
  },

  getContractReport: (param: IContractReportParam) =>
    axios.post<ContractReport>(`/Contract/GetContractReport`, param, {
      withCredentials: true,
    }),

  GetContractHistoryList: (param: IContractGetHistoryParam) =>
    axios.get<any>(`/Contract/GetContractHistoryList`, {
      params: param, // Pass the query parameters here
      withCredentials: true, // Add credentials option
    }),
};
//#endregion

//#region Customer
const Customer = {
  create: (data: ICustomer, file: Blob) => {
    let formData = new FormData();

    formData.append('englishFirstName', data.englishFirstName!);
    formData.append('pashtoFirstName', data.pashtoFirstName!);
    formData.append('englishSurName', data.englishSurName!);
    formData.append('pashtoSurName', data.pashtoSurName!);
    formData.append('englishFatherName', data.englishFatherName!);
    formData.append('pashtoFatherName', data.pashtoFatherName!);
    formData.append('englishGrandFatherName', data.englishGrandFatherName!);
    formData.append('pashtoGrandFatherName', data.pashtoGrandFatherName!);
    formData.append('tazkiraNo', data.tazkiraNo!);
    formData.append('branchId', data.branchId!.toString());
    formData.append('gender', data.gender!.toString());
    formData.append('bloodGroup', data.bloodGroup!.toString());
    formData.append('tazkiraTypeId', data.tazkiraTypeId!.toString());
    formData.append('dateOfBirth', data.dateOfBirth!.toDateString());
    formData.append('joldNo', data.joldNo!);
    formData.append('pageNo', data.pageNo!);
    formData.append('regNo', data.regNo!);
    formData.append('phoneNumber', data.phoneNumber!);
    formData.append('temporaryAddress', data.temporaryAddress!);
    formData.append('personalEmail', data.personalEmail!);
    formData.append('permenantAddress', data.permenantAddress!);
    formData.append('emergencyPhoneNumber', data.emergencyPhoneNumber!);
    formData.append('currentProvinceId', data.currentProvinceId?.toString() || '');
    formData.append('currentDistrictId', data.currentDistrictId?.toString() || '');
    formData.append('mainProvinceId', data.mainProvinceId?.toString() || '');
    formData.append('mainDistrictId', data.mainDistrictId?.toString() || '');
    formData.append('profilePhoto', file);
    formData.append('isActive', data.isActive!.toString());
    return axios.post<ICustomer, any>('/Customer', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  getList: (param: ICustomerParams) =>
    axios.post<any>(`/Customer/GetList`, param, { withCredentials: true }),
  update: (data: ICustomer, file: Blob) => {
    let formData = new FormData();

    formData.append('englishFirstName', data.englishFirstName!);
    formData.append('pashtoFirstName', data.pashtoFirstName!);
    formData.append('englishSurName', data.englishSurName!);
    formData.append('pashtoSurName', data.pashtoSurName!);
    formData.append('englishFatherName', data.englishFatherName!);
    formData.append('pashtoFatherName', data.pashtoFatherName!);
    formData.append('englishGrandFatherName', data.englishGrandFatherName!);
    formData.append('pashtoGrandFatherName', data.pashtoGrandFatherName!);
    formData.append('tazkiraNo', data.tazkiraNo!);
    formData.append('gender', data.gender!.toString());
    formData.append('bloodGroup', data.bloodGroup!.toString());
    formData.append('tazkiraTypeId', data.tazkiraTypeId!.toString());
    formData.append('dateOfBirth', data.dateOfBirth!.toDateString());
    formData.append('joldNo', data.joldNo!);
    formData.append('pageNo', data.pageNo!);
    formData.append('regNo', data.regNo!);
    formData.append('phoneNumber', data.phoneNumber!);
    formData.append('temporaryAddress', data.temporaryAddress!);
    formData.append('permenantAddress', data.permenantAddress!);
    formData.append('emergencyPhoneNumber', data.emergencyPhoneNumber!);
    formData.append('personalEmail', data.personalEmail!);
    formData.append('currentProvinceId', data.currentProvinceId?.toString() || '');
    formData.append('currentDistrictId', data.currentDistrictId?.toString() || '');
    formData.append('mainProvinceId', data.mainProvinceId?.toString() || '');
    formData.append('mainDistrictId', data.mainDistrictId?.toString() || '');
    formData.append('profilePhoto', file);
    formData.append('isActive', data.isActive!.toString());
    // formData.append('isCurrent', data.isCurrent!.toString());
    if (file) {
      formData.append('profilePhoto', file);
    }
    return axios.put<ICustomer>(`/Customer/${data.customerId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  detail: (empId: any) => requests.get<void>(`/Customer/GetDetail/${empId}`),
  delete: (id: number, remark: string) => axios.delete<void>(`/Customer/${id}`, { data: remark }),
  CustomerDetail: (id?: number) => requests.get<ICustomerDetails>(`/Customer/GetDetail/${id}`),
  CustomerDDLByCurrentBranch: () => axios.get<any>(`/Customer/GetEmplyeeDDLOfCurrentBranch`),
  CustomerDDL: () =>
    axios.get<any>(`/Customer/GetCustomerDDL`, {
      withCredentials: true,
    }),
  getCustomerRelatedDepartmentDDL: () =>
    axios.get<any>(`/Customer/GetRelatedUserInDepartment`, {
      withCredentials: true,
    }),
  getCustomerForEdit: (id: number) =>
    axios.get<any>(`/Customer/GetCustomerForEdit/${id}`, { withCredentials: true }),

  getCustomerAccountReport: (param: CustomerAccountReport) =>
    axios.post<any>(`/CustomerReport/Get-Customer-Reports`, param, { withCredentials: true }),
};
//#endregion

//#region ContractPayment
const ContractPayment = {
  create: (ContractPayment: IContractPayment) => requests.post<void>('/Province', ContractPayment),
  getList: (param: IContractPaymentParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (ContractPayment: IContractPayment) =>
    requests.put<void>(`/Province/${ContractPayment.id}`, ContractPayment),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  ContractPaymentDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
  ContractPaymentDDLByMainRegion: (MainRegionID: number) =>
    axios.get<any>(`/Province/GetProvinceByMainRegion/${MainRegionID}`, {
      withCredentials: true,
    }),
};
//#endregion

//#region Discount
const Discount = {
  create: (Discount: IDiscount) => requests.post<void>('/Province', Discount),
  getList: (param: IDiscountParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (Discount: IDiscount) => requests.put<void>(`/Province/${Discount.id}`, Discount),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  DiscountDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region FinanceReport
const FinanceReport = {
  create: (FinanceReport: IFinanceReport) => requests.post<void>('/Province', FinanceReport),
  getList: (param: IFinanceReportParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (FinanceReport: IFinanceReport) =>
    requests.put<void>(`/Province/${FinanceReport.id}`, FinanceReport),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  FinanceReportDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
};
//#endregion

//#region Income
const Income = {
  // create: (Income: Incomes) => requests.post<void>('/Income', Income),

  create: (data: Incomes, attach: Blob) => {
    let formData = new FormData();
    formData.append('incomeCategoryId', data.incomeCategoryId!.toString());
    formData.append('description', data.description!.toString());
    formData.append('carrencyId', data.carrencyId!.toString());
    formData.append('amount', data.amount!.toString());
    formData.append('branchId', data.branchId!.toString());
    formData.append('recieveDate', data.recieveDate!.toISOString());
    formData.append('serialNumber', data.serialNumber!.toString());
    formData.append('attachment', attach);
    return axios.post<Incomes, any>(`/Income`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  update: (data: Incomes, attach: Blob) => {
    let formData = new FormData();
    formData.append('incomeCategoryId', data.incomeCategoryId!.toString());
    formData.append('description', data.description!.toString());
    formData.append('carrencyId', data.carrencyId!.toString());
    formData.append('amount', data.amount!.toString());
    formData.append('branchId', data.branchId!.toString());

    formData.append('recieveDate', data.recieveDate!.toDateString());
    formData.append('attachment', attach);
    return axios.put<Incomes, any>(`/Income/${data.incomeId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  getList: (param: IncomeParams) =>
    axios.post<any>(`/Income/GetList/1`, param, { withCredentials: true }),
  // update: (Income: Incomes) => requests.put<void>(`/Income/${Income.incomeId}`, Income),
  delete: (id: number, remark: string) => axios.delete<void>(`/Income/${id}`, { data: remark }),
  IncomeDDL: () =>
    axios.get<any>(`/Income/GetIncomeDDL`, {
      withCredentials: true,
    }),
  getDetail: (id: number) => requests.get<Incomes>(`/Income/GetDetail/${id}`),

  getIncomReport: (param: IncomeRepotParam) =>
    axios.post<IncomReportData>(`/Income/GetIncomeReport`, param, {
      withCredentials: true,
    }),
  IncomeChartChart: () => axios.get(`/Income/IncomeLineChart`, { withCredentials: true }),
};
//#endregion

//#region IncomeReport
const IncomeReport = {
  create: (IncomeReport: IncomeReports) => requests.post<void>('/Province', IncomeReport),
  getList: (param: IncomeReportParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (IncomeReport: IncomeReports) =>
    requests.put<void>(`/Province/${IncomeReport.id}`, IncomeReport),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  IncomeReportDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
  IncomeReportDDLByMainRegion: (MainRegionID: number) =>
    axios.get<any>(`/Province/GetProvinceByMainRegion/${MainRegionID}`, {
      withCredentials: true,
    }),
};
//#endregion

//#region Financial Pyament
const FinancialPayment = {

  create: (data: IFinancialPayment, attach: Blob) => {
    let formData = new FormData();
    formData.append('description', data.description!.toString());
    formData.append('dollor', data.dollor!.toString());
    formData.append('afghani', data.afghani!.toString());
    formData.append('branchId', data.branchId!.toString());
    formData.append('paymentDate', data.paymentDate!.toISOString());
    formData.append('serialNumber', data.serialNumber!.toString());
    formData.append('attachment', attach);
    return axios.post<IFinancialPayment, any>(`/FinancialPayment`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  update: (data: IFinancialPayment, attach: Blob) => {
    let formData = new FormData();
    formData.append('description', data.description!.toString());
    formData.append('dollor', data.dollor!.toString());
    formData.append('afghani', data.afghani!.toString());
    formData.append('branchId', data.branchId!.toString());
    formData.append('serialNumber', data.serialNumber!.toString());
    formData.append('paymentDate', data.paymentDate!.toDateString());
    formData.append('attachment', attach);
    return axios.put<IFinancialPayment, any>(`/FinancialPayment/${data.financialPaymentId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  getList: (param: FinancialPaymentParams) =>
    axios.post<any>(`/FinancialPayment/GetList`, param, { withCredentials: true }),
  // update: (Income: Incomes) => requests.put<void>(`/Income/${Income.incomeId}`, Income),
  delete: (financialPaymentId: number, remark: string) => axios.delete<void>(`/FinancialPayment/${financialPaymentId}`, { data: remark }),

  getDetail: (financialPaymentId: number) => requests.get<IFinancialPayment>(`/FinancialPayment/GetDetail/${financialPaymentId}`),

};
//#endregion

//#region Map
const Map = {
  create: (Map: IMap) => requests.post<void>('/Province', Map),
  getList: (param: IMapParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (Map: IMap) => requests.put<void>(`/Province/${Map.id}`, Map),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  MapDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
  MapDDLByMainRegion: (MainRegionID: number) =>
    axios.get<any>(`/Province/GetProvinceByMainRegion/${MainRegionID}`, {
      withCredentials: true,
    }),
};
//#endregion

//#region Shop
const Shop = {
  create: (Shop: IShopInfo) => requests.post<void>('/Shop', Shop),
  getList: (param: IShopParams) =>
    axios.post<any>(`/Shop/GetList/1`, param, { withCredentials: true }),
  update: (Shop: IShopInfo) => requests.put<void>(`/Shop/${Shop.shopId}`, Shop),
  updateShopLocation: (Shop: ShopLocation) => axios.patch<void>(`/Shop/${Shop.shopId}`, Shop),
  delete: (id: number, remark: string) => axios.delete<void>(`/Shop/${id}`, { data: remark }),
  ShopDDL: (floorId: number, show?: boolean) =>
    axios.get<any>(`/Shop/GetShopDDL/${floorId}?ShowContractfulShops=${show}`, {
      withCredentials: true,
    }),
  getDetail: (id?: number) => requests.get<ShopDetail>(`/Shop/GetDetail/${id}`),
  getShopReport: (param: IShopReportParam) =>
    axios.post<ShopReportData>(`/Shop/GetShopReport`, param, {
      withCredentials: true,
    }),
  getShopForMap: (param: IShopReportParam) =>
    axios.post<IShopForMap[]>(`/Shop/GetShopForMap`, param, {
      withCredentials: true,
    }),
};
//#endregion

//#region ShopReport
const ShopReport = {
  create: (ShopReport: IShopReport) => requests.post<void>('/Province', ShopReport),
  getList: (param: IShopReportParams) =>
    axios.post<any>(`/Province/GetList`, param, { withCredentials: true }),
  update: (ShopReport: IShopReport) => requests.put<void>(`/Province/${ShopReport.id}`, ShopReport),
  delete: (id: number, remark: string) => axios.delete<void>(`/Province/${id}`, { data: remark }),
  ShopReportDDL: () =>
    axios.get<any>(`/Province/GetProvinceDDL`, {
      withCredentials: true,
    }),
};

//#endregion

//#region RentPayment
const RentPayment = {
  create: (data: IRentAdvancePayment, attach: Blob) => {
    let formData = new FormData();

    formData.append('contractId', data.contractId!.toString());
    formData.append('paidAmount', data.paidAmount!.toString());
    formData.append('description', data.description!.toString());
    formData.append('paymentDate', data.paymentDate!.toDateString());
    formData.append('serialNumber', data.serialNumber!.toString());
    formData.append('attachment', attach);

    // Format the durationOfAdvanceRent array as an object
    data.durationOfAdvanceRents.forEach((rent, index) => {
      formData.append(
        `durationOfAdvanceRent[${index}]`,
        JSON.stringify({
          year: rent.year,
          month: rent.month,
        })
      );
    });

    return axios.post<IRentPayment, any>(`/RentPayment`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },

  getList: (param: IRentPaymentParams) =>
    axios.get<any>(`/RentPayment/GetList/${param.years}`, {
      params: param, // Pass the query parameters here
      withCredentials: true, // Add credentials option
    }),

  update: (data: IRentPayment, attach: Blob) => {
    let formData = new FormData();
    formData.append('rentPaymentId', data.rentPaymentId!.toString());
    formData.append('contractId', data.contractId!.toString());
    formData.append('year', data.year!.toString());
    formData.append('month', data.month!.toString());
    if (data.paidAmount != null) {
      formData.append('paidAmount', data.paidAmount.toString());
    }
    formData.append('paymentMethod', data.paymentMethod!.toString());
    formData.append('paymentDate', data.paymentDate!.toDateString());
    formData.append('description', data.description!.toString());
    if (data.serialNumber != null && data.serialNumber !== '') {
      formData.append('serialNumber', data.serialNumber.toString());
    }
    if (attach) {
      formData.append('attachment', attach);
    }
    return axios.put<IRentPayment, any>(`/RentPayment/${data.rentPaymentId}`, formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  delete: (param: IRentPaymentDelete) => axios.delete<void>(`/RentPayment/delete`, { data: param }),
  RentPaymentDDL: () =>
    axios.get<any>(`/RentPayment/GetRentPaymentDDL`, {
      withCredentials: true,
    }),
  GenerateRentPaymentList: (RentPayment: IGeneratRentPaymentList) =>
    requests.post<void>('/RentPayment/Generate-RentPayment-List', RentPayment),
  getDetail: (Param: IRentPaymentDetailsParam) =>
    requests.post<any>(`/RentPayment/GetDetails/${Param.rentPaymentId}`, Param),

  getRentPaymentReport: (param: IRentPaymentReport) =>
    axios.post<RentReportData>(`/RentPayment/GetRentPaymentReport`, param, {
      withCredentials: true,
    }),
  getRentPaymentDailyReport: (param: IRentPaymentReport) =>
    axios.post<RentReportData>(`/RentPayment/GetRentPaymentReportDaily`, param, {
      withCredentials: true,
    }),
  GetHistory: (param: IGetRentHistoryParam) =>
    axios.get<any>(`/RentPayment/GetHistory`, {
      params: param, // Pass the query parameters here
      withCredentials: true, // Add credentials option
    }),
};
//#endregion

//#region ElectricityPayment
const ElectricityPayment = {
  create: (ElectricityPayment: IElectricityPayment) =>
    requests.post<void>('/ElectricityPayment', ElectricityPayment),
  // RecievePayment: (ElectricityPayment: IRecievePayment) =>
  //   requests.post<void>(
  //     `/ElectricityPayment/RecieveElectricityPayment/${ElectricityPayment.electricityPaymentId}`,
  //     ElectricityPayment
  //   ),

  // create: (ElectricityPayment: IElectricityPayment) => {

  //   let formData = new FormData();
  //   formData.append('electricMeterId', ElectricityPayment.electricMeterId!.toString());
  //   formData.append('startDate', ElectricityPayment.startDate!.toDateString());
  //   formData.append('endDate', ElectricityPayment.endDate!.toDateString());
  //   formData.append('serialNumber', ElectricityPayment.serialNumber!.toString());
  //   formData.append(
  //     'currentElectricMeterDegree',
  //     ElectricityPayment.currentElectricMeterDegree!.toString()
  //   );
  //   // formData.append('attachment', attach);
  //   return axios.post<IElectricityPayment,any>(`/ElectricityPayment`, formData, {
  //     headers: { 'Content-type': 'multipart/form-data' },
  //   });
  // },

  RecievePayment: (ElectricityPayment: IRecievePayment, attach: Blob) => {
    let formData = new FormData();
    formData.append('electricityPaymentId', ElectricityPayment.electricityPaymentId!.toString());
    formData.append('paymentDate', ElectricityPayment.paymentDate!.toDateString());
    formData.append('paidAmount', ElectricityPayment.paidAmount!.toString());
    if (ElectricityPayment.serialNumber) {
      formData.append('serialNumber', ElectricityPayment.serialNumber!.toString());
    }
    formData.append('attachment', attach);
    return axios.post<IRecievePayment, any>(
      `/ElectricityPayment/RecieveElectricityPayment/${ElectricityPayment.electricityPaymentId}`,
      formData,
      {
        headers: { 'Content-type': 'multipart/form-data' },
      }
    );
  },
  getList: (param: IElectricityPaymentParams) =>
    axios.get<any>(`/ElectricityPayment/GetList/${param.years}`, {
      params: param, // Pass the query parameters here
      withCredentials: true, // Add credentials option
    }),
  update: (ElectricityPayment: IElectricityPayment) =>
    requests.put<void>(
      `/ElectricityPayment/${ElectricityPayment.electricityPaymentId}`,
      ElectricityPayment
    ),
  delete: (param: IElectricityPaymentDelete) =>
    axios.delete<void>(`/ElectricityPayment/delete`, { data: param }),
  getDetail: (Param: IElectricityPaymentDetailsParam) =>
    requests.post<any>(`/ElectricityPayment/GetDetails/${Param.electricityPaymentId}`, Param),

  // getElectricityPaymentReport: (param: IElectricityPaymentReport) =>
  //   axios.get<any>(`/ElectricityPayment/GetElectricityPaymentReport`, {
  //     params: param, // Pass the query parameters here
  //     withCredentials: true, // Add credentials option
  //   }),

  getElectricityPaymentReport: (param: IElectricityPaymentReport) =>
    axios.post<ElectricReport>(`/ElectricityPayment/GetElectricityPaymentReport`, param, {
      withCredentials: true,
    }),
  getElectricityPaymentDailyReport: (param: IElectricityPaymentReport) =>
    axios.post<ElectricReport>(`/ElectricityPayment/GetElectricityPaymentReportDaily`, param, {
      withCredentials: true,
    }),

  GetHistory: (param: IGetHistoryParam) =>
    axios.get<any>(`/ElectricityPayment/GetHistory`, {
      params: param, // Pass the query parameters here
      withCredentials: true, // Add credentials option
    }),
};
//#endregion

//#region ElectricityPrice
const ElectricityPrice = {
  create: (ElectricityPrice: IElectricityPrice) =>
    requests.post<void>('/ElectricityPrice', ElectricityPrice),
  getList: (param: IElectricityPriceParams) =>
    axios.post<any>(`/ElectricityPrice/GetList`, param, { withCredentials: true }),
  update: (ElectricityPrice: IElectricityPrice) =>
    requests.put<void>(
      `/ElectricityPrice/${ElectricityPrice.electricityPriceId}`,
      ElectricityPrice
    ),
  delete: (electricityPriceId: number, remark: string) =>
    axios.delete<void>(`/ElectricityPrice/${electricityPriceId}`, { data: remark }),
  ElectricityPriceDDL: () =>
    axios.get<any>(`/ElectricityPrice/GetElectricityPriceDDL`, {
      withCredentials: true,
    }),
};

//#endregion

//#region dashboard
const Dashboard = {
  getDashboard: () => axios.get<ShopDashboardData>(`Dashboard/GetContractShopAndCustomerCount`),
};

//#endregion

//#endregion

//#endregion

const agent = {
  Logins,
  Permissions,
  ControllerNames,
  Lanugages,
  RolesAgent,
  createUser,
  Years,
  Notification,
  changeLanguage,
  Employees,
  EmployeesPosition,
  PositionTitle,
  JobPosition,
  Country,
  GetActiveEmp,
  GetParentEmp,
  province,
  district,
  ContractDetails,
  // NPFX MARKET
  Applications,
  trainingVideoAgent,
  ContractType,
  Block,
  ContractInfo,
  Customer,
  ContractPayment,
  Discount,
  FinanceReport,
  Income,
  IncomeReport,
  Map,
  Shop,
  ShopReport,
  ElectricBox,
  ElectricMeter,
  Floor,
  IncomeCategory,
  ShopContractType,
  Status,
  ShopType,
  CurrencyType,
  ElectricityPrice,
  RentPayment,
  TermsAndCondition,
  ElectricityPayment,
  Dashboard,
  HRContractType,
  FinancialPayment
};

export default agent;
